export type CardAttachmentDTO = {
  id?: string;
  createdById?: string;
  createdAt?: Date;
  title: string;
  type: AttachmentType;
  mimeType: string;
  isPublic: boolean;
  isActive: boolean;

  hospitalId?: string;
  consultantId?: string;
  procedureId?: string;

  uploadedFileName: string;
  optimisedFileName?: string;
  thumbnailFileName?: string;

  uploadedUrl?: string;
  optimisedUrl?: string;
  thumbnailUrl?: string;
};

export enum AttachmentType {
  AttachmentAdded = 'AttachmentAdded',
  AttachmentRemoved = 'AttachmentRemoved',
}
